export default __webpack_public_path__ + "static/media/09-460x460.7f3a1557.jpeg";